module.exports = __webpack_public_path__ + "static/media/youtube-white.723444ed.svg";